import { onBeforeMount, onUnmounted, shallowReactive, watch } from '@vue/composition-api';
import { debounce } from 'lodash';
export default function useSWR(fetcher, options = {}) {
    let lastPromise;
    let reloadDebounce;
    const reload = async () => {
        reloadDebounce?.cancel();
        const promise = fetcher();
        lastPromise = promise;
        response.loading = true;
        if (options.clearValueBeforeLoad) {
            response.value = undefined;
            response.error = null;
        }
        return promise.then((result) => {
            if (promise !== lastPromise)
                return lastPromise; // another req happens
            response.loading = false;
            if (options.updateHook) {
                options.updateHook(response, result);
            }
            else {
                response.value = result;
            }
            response.error = null;
            return result;
        }, (error) => {
            if (promise !== lastPromise)
                return lastPromise; // another req happens
            response.loading = false;
            if (options.clearValueIfError)
                response.value = undefined;
            response.error = error;
            throw error;
        });
    };
    const cancel = () => {
        reloadDebounce?.cancel();
        lastPromise = undefined;
    };
    const response = shallowReactive({
        loading: true,
        value: undefined,
        error: null,
        reload,
        cancel,
        waitForReady: () => lastPromise || reload(),
    });
    if (options.immediate)
        onBeforeMount(reload);
    if (options.watch) {
        if (options.watchDebounce)
            reloadDebounce = debounce(reload, options.watchDebounce);
        watch(options.watch, reloadDebounce || reload, { deep: !!options.watchDeep });
    }
    onUnmounted(cancel);
    return response;
}
